import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { getHomepage } from "../services/sanityService";
import { Project } from "../types/project";

const endpoint = process.env.REACT_APP_SANITY_URL;

if (endpoint === undefined) throw new Error("undefined env variable -> sanity url")


export const useHomepageQuery = (): UseQueryResult<{ introduction: string, projects: Project[] }> => {
  return useQuery(["homepage-data"], getHomepage);
}